import React, { useState } from "react";

type EventEHRToggleTabButtonProps = {
  tabs: string[];
  onToggle: (activeTab: string) => void;
  className?: string;
  defaultSelected?: string;
  variant: string;
  customWidth?: string;
};

const EventEHRToggleTabButton: React.FC<EventEHRToggleTabButtonProps> = ({
  tabs,
  onToggle,
  className,
  defaultSelected,
  customWidth,
}) => {
  const [activeTab, setActiveTab] = useState(defaultSelected || tabs[0]);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    onToggle(tab);
  };

  return (
    <div className="flex">
      <div
        className={`flex rounded-md border-[1px] py-[3.5px] px-[4px] gap-1 border-[#F5F5F5] bg-[#F9FAFB] justify-between h-auto w-full ${className}`}
        // style={
        //   width
        //     ? width
        //     : {
        //         width: "100%",
        //       }
        // }
        style={{
          width: customWidth || "100%",
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`text-sm font-medium gap-2 w-full py-2
                    ${activeTab === tab ? "bg-white text-[#005596] border-[1px] border-[#E9E9E9] rounded-[4px] " : "text-[#727272]"} 
                    `}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EventEHRToggleTabButton;
